export const keys = {
  // Site header
  RYTE_SITE: "RYTE_SITE",
  RYTE_SITE_PLACEHOLDER: "RYTE_SITE_PLACEHOLDER",
  RYTE_NO_SITES_FOUND: "RYTE_NO_SITES_FOUND",
  RYTE_SITES_ERROR: "RYTE_SITES_ERROR",

  // Metrics
  RYTE_ERROR_LOADING_METRICS: "RYTE_ERROR_LOADING_METRICS",
  RYTE_DOCK_UTILIZATION: "RYTE_DOCK_UTILIZATION",
  RYTE_PENDING_MOVES: "RYTE_PENDING_MOVES",
  RYTE_ACTIVE_ASSIGNMENTS: "RYTE_ACTIVE_ASSIGNMENTS",
  RYTE_COMPLETED_TODAY: "RYTE_COMPLETED_TODAY",

  // Empty state
  RYTE_EMPTY_STATE_TITLE: "RYTE_EMPTY_STATE_TITLE",
  RYTE_EMPTY_STATE_DESCRIPTION: "RYTE_EMPTY_STATE_DESCRIPTION",
  RYTE_EMPTY_STATE_NO_XD_TITLE: "RYTE_EMPTY_STATE_NO_XD_TITLE",
  RYTE_EMPTY_STATE_NO_XD_DESCRIPTION: "RYTE_EMPTY_STATE_NO_XD_DESCRIPTION",
  RYTE_EMPTY_STATE_NO_DOORS_TITLE: "RYTE_EMPTY_STATE_NO_DOORS_TITLE",
  RYTE_EMPTY_STATE_NO_DOORS_DESCRIPTION: "RYTE_EMPTY_STATE_NO_DOORS_DESCRIPTION",

  // Unscheduled trailers
  RYTE_UNSCHEDULED_TRAILERS: "RYTE_UNSCHEDULED_TRAILERS",
  RYTE_UNSCHEDULED_TRAILERS_CLOSE: "RYTE_UNSCHEDULED_TRAILERS_CLOSE",
  RYTE_QUEUE_DIRECTION_FILTER: "RYTE_QUEUE_DIRECTION_FILTER",
  RYTE_UNSCHEDULED_TRAILERS_SEARCH: "RYTE_UNSCHEDULED_TRAILERS_SEARCH",
  RYTE_QUEUE_COUNT_SUMMARY: "RYTE_QUEUE_COUNT_SUMMARY",
  RYTE_CARD_DETAIL_UNPLANNED: "RYTE_CARD_DETAIL_UNPLANNED",

  // Visit card
  RYTE_VISIT_ASSIGNING: "RYTE_VISIT_ASSIGNING",

  // Drop-to-create flow
  RYTE_DROP_SUCCESS: "RYTE_DROP_SUCCESS",
  RYTE_DROP_FAILURE: "RYTE_DROP_FAILURE",
  RYTE_DROP_DUPLICATE: "RYTE_DROP_DUPLICATE",
  RYTE_DROP_INVALID: "RYTE_DROP_INVALID",
  RYTE_DROP_PAST_TIME: "RYTE_DROP_PAST_TIME",
  RYTE_DROP_UNKNOWN_VISIT: "RYTE_DROP_UNKNOWN_VISIT",
  RYTE_DROP_UNKNOWN_DOOR: "RYTE_DROP_UNKNOWN_DOOR",
  RYTE_DROP_DIRECTION_MISMATCH: "RYTE_DROP_DIRECTION_MISMATCH",
  RYTE_DROP_CREATE_DISABLED: "RYTE_DROP_CREATE_DISABLED",
  RYTE_DROP_MALFORMED_RESPONSE: "RYTE_DROP_MALFORMED_RESPONSE",
  RYTE_DROP_TOO_MANY_IN_FLIGHT: "RYTE_DROP_TOO_MANY_IN_FLIGHT",
  RYTE_DROP_TARGET_IN_PROGRESS: "RYTE_DROP_TARGET_IN_PROGRESS",
  /**
   * Paired-drop partial failure — Primary goal was created successfully
   * but the companion Removal goal failed. The orphan Primary remains
   * visible on the timeline. MessageVars: { intent, content, dockDoor,
   * reason }. Per-spec R10.2.
   */
  RYTE_DROP_PARTIAL_FAILURE: "RYTE_DROP_PARTIAL_FAILURE",
  RYTE_DOOR_COLUMN_HEADER: "RYTE_DOOR_COLUMN_HEADER",

  // Drag-to-resize/move flow
  RYTE_DRAG_SUCCESS: "RYTE_DRAG_SUCCESS",
  RYTE_DRAG_RESIZED: "RYTE_DRAG_RESIZED",
  RYTE_DRAG_FAILURE: "RYTE_DRAG_FAILURE",
  RYTE_DRAG_MERGED_FAILURE: "RYTE_DRAG_MERGED_FAILURE",
  RYTE_DRAG_INVALID_ORDERING: "RYTE_DRAG_INVALID_ORDERING",
  RYTE_DRAG_STALE_RETRY: "RYTE_DRAG_STALE_RETRY",
  RYTE_ACTION_VERSION_CONFLICT: "RYTE_ACTION_VERSION_CONFLICT",

  // Goal tooltip
  RYTE_TOOLTIP_DURATION: "RYTE_TOOLTIP_DURATION",
  RYTE_TOOLTIP_CLICK_DETAILS: "RYTE_TOOLTIP_CLICK_DETAILS",
  RYTE_TOOLTIP_TRAILER: "RYTE_TOOLTIP_TRAILER",
  RYTE_TOOLTIP_LOCATION: "RYTE_TOOLTIP_LOCATION",
  RYTE_TOOLTIP_ARRIVAL: "RYTE_TOOLTIP_ARRIVAL",
  RYTE_TOOLTIP_DEPARTURE: "RYTE_TOOLTIP_DEPARTURE",
  RYTE_TOOLTIP_TAGS: "RYTE_TOOLTIP_TAGS",
  RYTE_TOOLTIP_PROCESSING: "RYTE_TOOLTIP_PROCESSING",
  RYTE_TOOLTIP_STAGE_PENDING: "RYTE_TOOLTIP_STAGE_PENDING",
  RYTE_TOOLTIP_STAGE_HOSTLER_CREATE: "RYTE_TOOLTIP_STAGE_HOSTLER_CREATE",
  RYTE_TOOLTIP_STAGE_TDR_IN: "RYTE_TOOLTIP_STAGE_TDR_IN",
  RYTE_TOOLTIP_STAGE_PROCESSING: "RYTE_TOOLTIP_STAGE_PROCESSING",
  RYTE_TOOLTIP_STAGE_TDR_OUT: "RYTE_TOOLTIP_STAGE_TDR_OUT",
  RYTE_TOOLTIP_STAGE_HOSTLER_REMOVE: "RYTE_TOOLTIP_STAGE_HOSTLER_REMOVE",
  RYTE_TOOLTIP_STAGE_COMPLETED: "RYTE_TOOLTIP_STAGE_COMPLETED",
  RYTE_TOOLTIP_DEST: "RYTE_TOOLTIP_DEST",
  RYTE_TOOLTIP_TIMES: "RYTE_TOOLTIP_TIMES",
  RYTE_TOOLTIP_CPT: "RYTE_TOOLTIP_CPT",
  RYTE_TOOLTIP_CUT: "RYTE_TOOLTIP_CUT",
  RYTE_TOOLTIP_ATTACHED: "RYTE_TOOLTIP_ATTACHED",
  RYTE_TOOLTIP_NOT_ATTACHED: "RYTE_TOOLTIP_NOT_ATTACHED",
  RYTE_TOOLTIP_STATUS_IN_PROGRESS: "RYTE_TOOLTIP_STATUS_IN_PROGRESS",
  RYTE_TOOLTIP_STATUS_PLANNED: "RYTE_TOOLTIP_STATUS_PLANNED",
  RYTE_TOOLTIP_STATUS_ON_HOLD: "RYTE_TOOLTIP_STATUS_ON_HOLD",
  RYTE_TOOLTIP_STATUS_COMPLETED: "RYTE_TOOLTIP_STATUS_COMPLETED",
  RYTE_TOOLTIP_STATUS_FAILED: "RYTE_TOOLTIP_STATUS_FAILED",
  RYTE_TOOLTIP_STATUS_CANCELED: "RYTE_TOOLTIP_STATUS_CANCELED",
  RYTE_TOOLTIP_STATUS_CANCELLED_APPOINTMENT: "RYTE_TOOLTIP_STATUS_CANCELLED_APPOINTMENT",
  RYTE_PUCK_TIME_OPEN: "RYTE_PUCK_TIME_OPEN",
  RYTE_PUCK_EVENT_AREA_LABEL: "RYTE_PUCK_EVENT_AREA_LABEL",
  RYTE_PUCK_NO_TRAILER_LABEL: "RYTE_PUCK_NO_TRAILER_LABEL",
  RYTE_PUCK_PENDING_TRAILER: "RYTE_PUCK_PENDING_TRAILER",
  RYTE_PUCK_EXTRA_HAUL_IDS_LABEL: "RYTE_PUCK_EXTRA_HAUL_IDS_LABEL",
  RYTE_PUCK_VIEW_ONLY: "RYTE_PUCK_VIEW_ONLY",
  RYTE_PUCK_PARKED_AT_DOOR: "RYTE_PUCK_PARKED_AT_DOOR",
  RYTE_PUCK_MANAGED_EXTERNALLY: "RYTE_PUCK_MANAGED_EXTERNALLY",
  // Placeholder for the action-modal TimeSelect dropdowns (15-min options).
  RYTE_TIME_SELECT_PLACEHOLDER: "RYTE_TIME_SELECT_PLACEHOLDER",

  // Merged goal detail panel
  RYTE_MERGED_GOAL_PRIMARY: "RYTE_MERGED_GOAL_PRIMARY",

  // Goal detail panel
  RYTE_GOAL_DETAIL: "RYTE_GOAL_DETAIL",

  // Dock door type labels
  RYTE_DOCK_TYPE_INBOUND: "RYTE_DOCK_TYPE_INBOUND",
  RYTE_DOCK_TYPE_OUTBOUND: "RYTE_DOCK_TYPE_OUTBOUND",
  RYTE_DOCK_TYPE_MIXED: "RYTE_DOCK_TYPE_MIXED",
  // Dock door TDR (Trailer Dock & Release) chip — red when a trailer is
  // docked, green when clear. *_ARIA keys are the screen-reader labels.
  RYTE_DOOR_TDR_IN: "RYTE_DOOR_TDR_IN",
  RYTE_DOOR_TDR_CLEAR: "RYTE_DOOR_TDR_CLEAR",
  RYTE_DOOR_TDR_IN_ARIA: "RYTE_DOOR_TDR_IN_ARIA",
  RYTE_DOOR_TDR_CLEAR_ARIA: "RYTE_DOOR_TDR_CLEAR_ARIA",
  RYTE_GOAL_ID: "RYTE_GOAL_ID",
  RYTE_GOAL_STATUS: "RYTE_GOAL_STATUS",
  RYTE_GOAL_LOCATION: "RYTE_GOAL_LOCATION",
  // R6: Off-door displacement — planned vs current location labels
  RYTE_GOAL_PLANNED_LOCATION: "RYTE_GOAL_PLANNED_LOCATION",
  RYTE_GOAL_CURRENT_LOCATION: "RYTE_GOAL_CURRENT_LOCATION",
  RYTE_BADGE_OFF_DOOR: "RYTE_BADGE_OFF_DOOR",
  RYTE_GOAL_TAGS: "RYTE_GOAL_TAGS",
  RYTE_GOAL_DEMAND_ID: "RYTE_GOAL_DEMAND_ID",
  RYTE_GOAL_RELATED_TOOLS: "RYTE_GOAL_RELATED_TOOLS",
  RYTE_GOAL_LINK_FMC: "RYTE_GOAL_LINK_FMC",
  RYTE_GOAL_LINK_RTT: "RYTE_GOAL_LINK_RTT",
  RYTE_GOAL_ALL_DEMAND_IDS: "RYTE_GOAL_ALL_DEMAND_IDS",
  RYTE_GOAL_DELAYED: "RYTE_GOAL_DELAYED",
  RYTE_GOAL_EXECUTION_WINDOW: "RYTE_GOAL_EXECUTION_WINDOW",
  RYTE_GOAL_CREATED_AT: "RYTE_GOAL_CREATED_AT",
  RYTE_GOAL_REQUESTER: "RYTE_GOAL_REQUESTER",
  RYTE_GOAL_CREATED_BY_SYSTEM: "RYTE_GOAL_CREATED_BY_SYSTEM",
  RYTE_GOAL_LAST_UPDATED_BY_SYSTEM: "RYTE_GOAL_LAST_UPDATED_BY_SYSTEM",
  RYTE_GOAL_LOADING: "RYTE_GOAL_LOADING",
  RYTE_GOAL_UPDATED_AT: "RYTE_GOAL_UPDATED_AT",
  RYTE_GOAL_VERSION: "RYTE_GOAL_VERSION",
  RYTE_GOAL_STATUS_REASON: "RYTE_GOAL_STATUS_REASON",
  RYTE_GOAL_OVERRIDE_REASON: "RYTE_GOAL_OVERRIDE_REASON",
  RYTE_GOAL_CLOSE: "RYTE_GOAL_CLOSE",
  RYTE_COPY_VALUE: "RYTE_COPY_VALUE",
  RYTE_COPY_VALUE_SUCCESS: "RYTE_COPY_VALUE_SUCCESS",
  RYTE_COPY_VALUE_ERROR: "RYTE_COPY_VALUE_ERROR",
  RYTE_CARD_DETAIL_VISIT_TITLE: "RYTE_CARD_DETAIL_VISIT_TITLE",
  RYTE_CARD_DETAIL_APPOINTMENT_TITLE: "RYTE_CARD_DETAIL_APPOINTMENT_TITLE",
  RYTE_CARD_DETAIL_CLOSE: "RYTE_CARD_DETAIL_CLOSE",
  RYTE_GOAL_DELAYED_YES: "RYTE_GOAL_DELAYED_YES",
  RYTE_GOAL_DELAYED_NO: "RYTE_GOAL_DELAYED_NO",
  RYTE_GOAL_EXECUTION_WINDOW_RANGE: "RYTE_GOAL_EXECUTION_WINDOW_RANGE",
  RYTE_GOAL_DEMAND_LOCATION: "RYTE_GOAL_DEMAND_LOCATION",
  RYTE_GOAL_DEMAND_VISIT: "RYTE_GOAL_DEMAND_VISIT",
  RYTE_GOAL_DEMAND_EQUIPMENT: "RYTE_GOAL_DEMAND_EQUIPMENT",
  RYTE_GOAL_DEMAND_VRID: "RYTE_GOAL_DEMAND_VRID",
  RYTE_GOAL_DEMAND_LP: "RYTE_GOAL_DEMAND_LP",
  RYTE_GOAL_DEMAND_ISA: "RYTE_GOAL_DEMAND_ISA",

  // Merged-puck REMOVE-goal rows (folded into the single-goal layout)
  RYTE_GOAL_REMOVAL_LOCATION: "RYTE_GOAL_REMOVAL_LOCATION",
  RYTE_GOAL_REMOVAL_WINDOW: "RYTE_GOAL_REMOVAL_WINDOW",
  RYTE_GOAL_REMOVAL_STATUS: "RYTE_GOAL_REMOVAL_STATUS",

  // Toolbar
  RYTE_TOOLBAR_ZOOM_IN: "RYTE_TOOLBAR_ZOOM_IN",
  RYTE_TOOLBAR_ZOOM_OUT: "RYTE_TOOLBAR_ZOOM_OUT",

  // Debug (gamma only)
  RYTE_DEBUG_MODE_TOGGLE: "RYTE_DEBUG_MODE_TOGGLE",
  RYTE_DEBUG_GOAL_DEBUGGER: "RYTE_DEBUG_GOAL_DEBUGGER",
  RYTE_DEBUG_DATA: "RYTE_DEBUG_DATA",
  RYTE_DEBUG_COPY_VISIT_JSON: "RYTE_DEBUG_COPY_VISIT_JSON",
  RYTE_DEBUG_COPY_APPOINTMENT_JSON: "RYTE_DEBUG_COPY_APPOINTMENT_JSON",
  RYTE_DEBUG_COPY_JSON: "RYTE_DEBUG_COPY_JSON",
  RYTE_ROW_DEBUG_METADATA: "RYTE_ROW_DEBUG_METADATA",
  RYTE_DEBUG_COPY_AI_JSON: "RYTE_DEBUG_COPY_AI_JSON",
  RYTE_DEBUG_COPY_PUCK_JSON: "RYTE_DEBUG_COPY_PUCK_JSON",
  RYTE_DEBUG_COPY_PUCK_AI_JSON: "RYTE_DEBUG_COPY_PUCK_AI_JSON",
  RYTE_DEBUG_COPY_MOVE_JSON: "RYTE_DEBUG_COPY_MOVE_JSON",
  RYTE_DEBUG_TIME_RANGE_BUTTON: "RYTE_DEBUG_TIME_RANGE_BUTTON",
  RYTE_DEBUG_TIME_RANGE_ACTIVE: "RYTE_DEBUG_TIME_RANGE_ACTIVE",
  RYTE_DEBUG_TIME_RANGE_TITLE: "RYTE_DEBUG_TIME_RANGE_TITLE",
  RYTE_DEBUG_TIME_RANGE_CLOSE: "RYTE_DEBUG_TIME_RANGE_CLOSE",
  RYTE_DEBUG_TIME_RANGE_DESCRIPTION: "RYTE_DEBUG_TIME_RANGE_DESCRIPTION",
  RYTE_DEBUG_TIME_RANGE_PAST: "RYTE_DEBUG_TIME_RANGE_PAST",
  RYTE_DEBUG_TIME_RANGE_FUTURE: "RYTE_DEBUG_TIME_RANGE_FUTURE",
  RYTE_DEBUG_TIME_RANGE_CONSTRAINT: "RYTE_DEBUG_TIME_RANGE_CONSTRAINT",
  RYTE_DEBUG_TIME_RANGE_SUMMARY: "RYTE_DEBUG_TIME_RANGE_SUMMARY",
  RYTE_DEBUG_TIME_RANGE_RELOAD_NOTICE: "RYTE_DEBUG_TIME_RANGE_RELOAD_NOTICE",
  RYTE_DEBUG_TIME_RANGE_RESET: "RYTE_DEBUG_TIME_RANGE_RESET",
  RYTE_DEBUG_TIME_RANGE_CANCEL: "RYTE_DEBUG_TIME_RANGE_CANCEL",
  RYTE_DEBUG_TIME_RANGE_APPLY: "RYTE_DEBUG_TIME_RANGE_APPLY",
  RYTE_MOVE_DETAIL: "RYTE_MOVE_DETAIL",
  RYTE_MOVE_REQUESTED_BY: "RYTE_MOVE_REQUESTED_BY",
  RYTE_MOVE_EXECUTION_SYSTEM: "RYTE_MOVE_EXECUTION_SYSTEM",
  RYTE_MOVE_ID: "RYTE_MOVE_ID",
  RYTE_MOVE_DEPENDS_ON: "RYTE_MOVE_DEPENDS_ON",
  RYTE_EVENT_HISTORY: "RYTE_EVENT_HISTORY",
  RYTE_EVENT_HISTORY_BY_DEMAND_ID: "RYTE_EVENT_HISTORY_BY_DEMAND_ID",
  RYTE_EVENT_HISTORY_BY_VRID: "RYTE_EVENT_HISTORY_BY_VRID",
  RYTE_EVENT_HISTORY_BY_ISA: "RYTE_EVENT_HISTORY_BY_ISA",
  RYTE_EVENT_HISTORY_BY_EQUIPMENT_ID: "RYTE_EVENT_HISTORY_BY_EQUIPMENT_ID",
  RYTE_EVENT_REQUESTER_SYSTEM: "RYTE_EVENT_REQUESTER_SYSTEM",
  RYTE_EVENT_REQUESTER_USER_ID: "RYTE_EVENT_REQUESTER_USER_ID",
  RYTE_DEBUG_JSON_COPIED: "RYTE_DEBUG_JSON_COPIED",

  // Appointment cards
  RYTE_APPOINTMENTS_DATA: "RYTE_APPOINTMENTS_DATA",
  RYTE_APPOINTMENTS_DATA_COUNT: "RYTE_APPOINTMENTS_DATA_COUNT",
  RYTE_APPOINTMENTS_DATA_OUTBOUND: "RYTE_APPOINTMENTS_DATA_OUTBOUND",
  RYTE_APPOINTMENTS_DATA_OUTBOUND_COUNT: "RYTE_APPOINTMENTS_DATA_OUTBOUND_COUNT",
  RYTE_APPOINTMENTS_EMPTY: "RYTE_APPOINTMENTS_EMPTY",
  RYTE_APPOINTMENTS_ERROR: "RYTE_APPOINTMENTS_ERROR",
  RYTE_VISITS_ERROR: "RYTE_VISITS_ERROR",
  // Chart-level errors
  RYTE_CHART_ERROR: "RYTE_CHART_ERROR",
  RYTE_CHART_RETRY: "RYTE_CHART_RETRY",
  RYTE_CHART_CRASH: "RYTE_CHART_CRASH",
  // First-paint readiness gate — bars withheld until all four seed sources
  // settle for the site. Rows stay visible, so these are inline, not full-page.
  RYTE_CHART_LOADING_BARS: "RYTE_CHART_LOADING_BARS",
  RYTE_CHART_PARTIAL_DATA: "RYTE_CHART_PARTIAL_DATA",
  RYTE_DROP_BLOCKED_LOADING: "RYTE_DROP_BLOCKED_LOADING",
  RYTE_VISITS_MAIN_YARD: "RYTE_VISITS_MAIN_YARD",
  RYTE_VISITS_MAIN_YARD_COUNT: "RYTE_VISITS_MAIN_YARD_COUNT",
  RYTE_VISITS_MAIN_YARD_EMPTY: "RYTE_VISITS_MAIN_YARD_EMPTY",
  RYTE_VISITS_OFFSITE: "RYTE_VISITS_OFFSITE",
  RYTE_VISITS_OFFSITE_COUNT: "RYTE_VISITS_OFFSITE_COUNT",
  RYTE_VISITS_OFFSITE_EMPTY: "RYTE_VISITS_OFFSITE_EMPTY",
  RYTE_APPOINTMENT_ASSIGNING: "RYTE_APPOINTMENT_ASSIGNING",

  // Card tag labels
  RYTE_CARD_INBOUND: "RYTE_CARD_INBOUND",
  RYTE_CARD_OUTBOUND: "RYTE_CARD_OUTBOUND",

  // Card column labels (new queue-card redesign — labeled grid)
  RYTE_CARD_COLUMN_ORIGIN: "RYTE_CARD_COLUMN_ORIGIN",
  RYTE_CARD_COLUMN_SAT: "RYTE_CARD_COLUMN_SAT",
  RYTE_CARD_COLUMN_DEST: "RYTE_CARD_COLUMN_DEST",
  RYTE_CARD_COLUMN_CUT: "RYTE_CARD_COLUMN_CUT",
  RYTE_CARD_COLUMN_DWELL: "RYTE_CARD_COLUMN_DWELL",
  RYTE_CARD_COLUMN_CARRIER: "RYTE_CARD_COLUMN_CARRIER",

  // Sort dropdown
  RYTE_SORT_PRIORITY: "RYTE_SORT_PRIORITY",
  RYTE_SORT_DWELL: "RYTE_SORT_DWELL",
  RYTE_SORT_AAT: "RYTE_SORT_AAT",
  RYTE_SORT_ETA: "RYTE_SORT_ETA",

  RYTE_GOAL_ACTION_RELEASE: "RYTE_GOAL_ACTION_RELEASE",
  RYTE_GOAL_ACTION_RELEASE_SUCCESS: "RYTE_GOAL_ACTION_RELEASE_SUCCESS",
  RYTE_GOAL_ACTION_ERROR: "RYTE_GOAL_ACTION_ERROR",

  // Puck-mode-gated detail-panel actions (matrix §8d)
  RYTE_PUCK_ACTIONS: "RYTE_PUCK_ACTIONS",
  RYTE_PUCK_ACTION_MANAGE_EXTERNALLY: "RYTE_PUCK_ACTION_MANAGE_EXTERNALLY",
  RYTE_PUCK_ACTION_ATTACH_TRAILER: "RYTE_PUCK_ACTION_ATTACH_TRAILER",
  RYTE_PUCK_ACTION_CANCEL_VRID: "RYTE_PUCK_ACTION_CANCEL_VRID",
  RYTE_PUCK_ACTION_HOLD_AND_STAGE: "RYTE_PUCK_ACTION_HOLD_AND_STAGE",
  RYTE_PUCK_ACTION_HOLD_AND_STAGE_DISABLED_REMOVE_IN_PROGRESS:
    "RYTE_PUCK_ACTION_HOLD_AND_STAGE_DISABLED_REMOVE_IN_PROGRESS",
  RYTE_PUCK_ACTION_HOLD_AND_STAGE_DISABLED_XD_CHAIN:
    "RYTE_PUCK_ACTION_HOLD_AND_STAGE_DISABLED_XD_CHAIN",
  /**
   * A hostler is PHYSICALLY hauling this trailer right now — the REMOVE's move
   * is `EXECUTION_IN_PROGRESS` per `getYardMoves`. Replaces the old goal-status
   * proxy (`ACTIVE`) as the "haul underway" signal; see
   * `isHoldAndStageDisabledByMoveInProgress`. Ranked above the no-path copy
   * (concrete, yard-verifiable state) and below the removal-finished copy
   * (goal terminality is the stronger fact).
   */
  RYTE_PUCK_ACTION_HOLD_AND_STAGE_DISABLED_MOVE_IN_PROGRESS:
    "RYTE_PUCK_ACTION_HOLD_AND_STAGE_DISABLED_MOVE_IN_PROGRESS",
  /**
   * Hold at Door has NO usable branch: the REMOVE is past `updateGoal` AND
   * cancelling it is unsafe/undeterminable (other planned work depends on it),
   * so both the specific-time and open-ended paths would refuse inside the
   * modal. Menu-level so the operator never opens an unsubmittable dialog.
   * Slotted after the XD-chain and removal-finished branches, whose copy is
   * more specific.
   */
  RYTE_PUCK_ACTION_HOLD_AND_STAGE_DISABLED_NO_PATH:
    "RYTE_PUCK_ACTION_HOLD_AND_STAGE_DISABLED_NO_PATH",
  /**
   * Cancel Plan refused because a constituent goal is COMPLETED — part of this
   * puck's work is physically done, and the engine refuses `requestCancelGoal`
   * on a COMPLETED goal (`CANCELABLE_STATUSES`). Exempt on a live cross-dock
   * chain, whose COMPLETED inbound unload is an ordinary mid-life state.
   */
  RYTE_PUCK_ACTION_CANCEL_DISABLED_WORK_COMPLETED:
    "RYTE_PUCK_ACTION_CANCEL_DISABLED_WORK_COMPLETED",
  /**
   * Cancel Plan refused because the yard move behind the goal it would cancel is
   * `EXECUTION_IN_PROGRESS` (hostler hauling now) or `COMPLETED` (the haul has
   * already happened). Deliberately one key for both: the operator's next step is
   * the same either way — use Remove Trailer, not Cancel Plan — and naming which
   * of the two states applies would expose move vocabulary the timeline does not
   * otherwise surface.
   */
  RYTE_PUCK_ACTION_CANCEL_DISABLED_MOVE_UNDERWAY: "RYTE_PUCK_ACTION_CANCEL_DISABLED_MOVE_UNDERWAY",
  RYTE_PUCK_ACTION_KEEP_AT_DOOR: "RYTE_PUCK_ACTION_KEEP_AT_DOOR",
  RYTE_PUCK_ACTION_KEEP_AT_DOOR_DISABLED_REMOVE_NOT_UPDATABLE:
    "RYTE_PUCK_ACTION_KEEP_AT_DOOR_DISABLED_REMOVE_NOT_UPDATABLE",
  RYTE_PUCK_ACTION_MANUAL_MOVE: "RYTE_PUCK_ACTION_MANUAL_MOVE",
  RYTE_PUCK_ACTION_FLIP_TRAILER_TO_OB: "RYTE_PUCK_ACTION_FLIP_TRAILER_TO_OB",
  RYTE_PUCK_ACTION_IB_DOOR_TRANSFER: "RYTE_PUCK_ACTION_IB_DOOR_TRANSFER",
  RYTE_PUCK_ACTION_IB_DOOR_TRANSFER_DISABLED_EXISTS:
    "RYTE_PUCK_ACTION_IB_DOOR_TRANSFER_DISABLED_EXISTS",
  RYTE_PUCK_ACTION_REMOVE_IB_DOOR_TRANSFER: "RYTE_PUCK_ACTION_REMOVE_IB_DOOR_TRANSFER",
  RYTE_PUCK_ACTION_EDIT_IB_DOOR_TRANSFER: "RYTE_PUCK_ACTION_EDIT_IB_DOOR_TRANSFER",
  RYTE_PUCK_ACTION_UNLINK_CROSS_DOCK: "RYTE_PUCK_ACTION_UNLINK_CROSS_DOCK",
  RYTE_PUCK_ACTION_UNLINK_CROSS_DOCK_DISABLED_PAST_HORIZON:
    "RYTE_PUCK_ACTION_UNLINK_CROSS_DOCK_DISABLED_PAST_HORIZON",
  RYTE_PUCK_ACTION_DISABLED_TEMP_PENDING: "RYTE_PUCK_ACTION_DISABLED_TEMP_PENDING",
  RYTE_PUCK_ACTION_DISABLED_PENDING_CANCEL: "RYTE_PUCK_ACTION_DISABLED_PENDING_CANCEL",
  RYTE_PUCK_ACTION_DISABLED_PENDING_HOLD: "RYTE_PUCK_ACTION_DISABLED_PENDING_HOLD",
  RYTE_PUCK_ACTION_DISABLED_UPDATING: "RYTE_PUCK_ACTION_DISABLED_UPDATING",
  RYTE_PUCK_ACTION_DISABLED_DIRECTION: "RYTE_PUCK_ACTION_DISABLED_DIRECTION",
  RYTE_PUCK_ACTION_DISABLED_CANCEL_DIRECTION: "RYTE_PUCK_ACTION_DISABLED_CANCEL_DIRECTION",
  RYTE_PUCK_ACTION_DISABLED_NOT_YARD360: "RYTE_PUCK_ACTION_DISABLED_NOT_YARD360",
  RYTE_PUCK_ACTION_DISABLED_IB_DOOR_TRANSFER: "RYTE_PUCK_ACTION_DISABLED_IB_DOOR_TRANSFER",
  RYTE_XD_REJECT_TARGET_NOT_YARD360: "RYTE_XD_REJECT_TARGET_NOT_YARD360",
  RYTE_XD_REJECT_TARGET_IB_TRANSFER: "RYTE_XD_REJECT_TARGET_IB_TRANSFER",
  RYTE_PUCK_ACTION_REMOVE_TRAILER_DISABLED_NOTHING:
    "RYTE_PUCK_ACTION_REMOVE_TRAILER_DISABLED_NOTHING",
  RYTE_PUCK_ACTION_REMOVE_TRAILER_DISABLED_NO_VISIT:
    "RYTE_PUCK_ACTION_REMOVE_TRAILER_DISABLED_NO_VISIT",
  RYTE_PUCK_ACTION_REMOVE_TRAILER_DISABLED_AMBIGUOUS_VISITS:
    "RYTE_PUCK_ACTION_REMOVE_TRAILER_DISABLED_AMBIGUOUS_VISITS",
  RYTE_PUCK_ACTION_REMOVE_TRAILER_DISABLED_DUPLICATE:
    "RYTE_PUCK_ACTION_REMOVE_TRAILER_DISABLED_DUPLICATE",
  RYTE_PUCK_PENDING_CANCEL: "RYTE_PUCK_PENDING_CANCEL",
  RYTE_PUCK_PENDING_HOLD: "RYTE_PUCK_PENDING_HOLD",
  RYTE_PUCK_ACTION_CANCEL_VRID_SUCCESS: "RYTE_PUCK_ACTION_CANCEL_VRID_SUCCESS",
  RYTE_PUCK_ACTION_ERROR: "RYTE_PUCK_ACTION_ERROR",
  RYTE_PUCK_ACTION_NO_PRIMARY_GOAL: "RYTE_PUCK_ACTION_NO_PRIMARY_GOAL",

  // Mock-only OB trailer attachment prototype
  RYTE_ATTACH_TRAILER_REVIEW_TITLE: "RYTE_ATTACH_TRAILER_REVIEW_TITLE",
  RYTE_ATTACH_TRAILER_SELECT_TITLE: "RYTE_ATTACH_TRAILER_SELECT_TITLE",
  RYTE_ATTACH_TRAILER_CLOSE: "RYTE_ATTACH_TRAILER_CLOSE",
  RYTE_ATTACH_TRAILER_PROTOTYPE_NOTICE: "RYTE_ATTACH_TRAILER_PROTOTYPE_NOTICE",
  RYTE_ATTACH_TRAILER_LOAD: "RYTE_ATTACH_TRAILER_LOAD",
  RYTE_ATTACH_TRAILER_LOAD_ID: "RYTE_ATTACH_TRAILER_LOAD_ID",
  RYTE_ATTACH_TRAILER_CARRIER: "RYTE_ATTACH_TRAILER_CARRIER",
  RYTE_ATTACH_TRAILER_SUB_CARRIER: "RYTE_ATTACH_TRAILER_SUB_CARRIER",
  RYTE_ATTACH_TRAILER_CPT: "RYTE_ATTACH_TRAILER_CPT",
  RYTE_ATTACH_TRAILER_PREFERRED_LOCATION: "RYTE_ATTACH_TRAILER_PREFERRED_LOCATION",
  RYTE_ATTACH_TRAILER_RECOMMENDED: "RYTE_ATTACH_TRAILER_RECOMMENDED",
  RYTE_ATTACH_TRAILER_SELECTED: "RYTE_ATTACH_TRAILER_SELECTED",
  RYTE_ATTACH_TRAILER_NO_SELECTION: "RYTE_ATTACH_TRAILER_NO_SELECTION",
  RYTE_ATTACH_TRAILER_TRAILER_NUMBER: "RYTE_ATTACH_TRAILER_TRAILER_NUMBER",
  RYTE_ATTACH_TRAILER_TRAILER_ID: "RYTE_ATTACH_TRAILER_TRAILER_ID",
  RYTE_ATTACH_TRAILER_TRAILER_TYPE: "RYTE_ATTACH_TRAILER_TRAILER_TYPE",
  RYTE_ATTACH_TRAILER_CURRENT_LOCATION: "RYTE_ATTACH_TRAILER_CURRENT_LOCATION",
  RYTE_ATTACH_TRAILER_REGISTRATION_COUNTRY: "RYTE_ATTACH_TRAILER_REGISTRATION_COUNTRY",
  RYTE_ATTACH_TRAILER_ELIGIBLE: "RYTE_ATTACH_TRAILER_ELIGIBLE",
  RYTE_ATTACH_TRAILER_LOADABLE: "RYTE_ATTACH_TRAILER_LOADABLE",
  RYTE_ATTACH_TRAILER_RECOMMENDATION_GROUP: "RYTE_ATTACH_TRAILER_RECOMMENDATION_GROUP",
  RYTE_ATTACH_TRAILER_DETAILS_PENDING: "RYTE_ATTACH_TRAILER_DETAILS_PENDING",
  RYTE_ATTACH_TRAILER_WHY_RECOMMENDED: "RYTE_ATTACH_TRAILER_WHY_RECOMMENDED",
  RYTE_ATTACH_TRAILER_SELECT_DIFFERENT: "RYTE_ATTACH_TRAILER_SELECT_DIFFERENT",
  RYTE_ATTACH_TRAILER_SEARCH: "RYTE_ATTACH_TRAILER_SEARCH",
  RYTE_ATTACH_TRAILER_SEARCH_PLACEHOLDER: "RYTE_ATTACH_TRAILER_SEARCH_PLACEHOLDER",
  RYTE_ATTACH_TRAILER_RESULTS_COUNT: "RYTE_ATTACH_TRAILER_RESULTS_COUNT",
  RYTE_ATTACH_TRAILER_PENDING_TOOLTIP: "RYTE_ATTACH_TRAILER_PENDING_TOOLTIP",
  RYTE_ATTACH_TRAILER_CANDIDATE_TABLE: "RYTE_ATTACH_TRAILER_CANDIDATE_TABLE",
  RYTE_ATTACH_TRAILER_SELECT_CANDIDATE: "RYTE_ATTACH_TRAILER_SELECT_CANDIDATE",
  RYTE_ATTACH_TRAILER_NO_RESULTS: "RYTE_ATTACH_TRAILER_NO_RESULTS",
  RYTE_ATTACH_TRAILER_BACK: "RYTE_ATTACH_TRAILER_BACK",
  RYTE_ATTACH_TRAILER_CANCEL: "RYTE_ATTACH_TRAILER_CANCEL",
  RYTE_ATTACH_TRAILER_CHOOSE_DIFFERENT: "RYTE_ATTACH_TRAILER_CHOOSE_DIFFERENT",
  RYTE_ATTACH_TRAILER_SUBMIT: "RYTE_ATTACH_TRAILER_SUBMIT",
  RYTE_ATTACH_TRAILER_SIMULATED_SUCCESS: "RYTE_ATTACH_TRAILER_SIMULATED_SUCCESS",
  RYTE_ATTACH_TRAILER_SUCCESS: "RYTE_ATTACH_TRAILER_SUCCESS",
  RYTE_ATTACH_TRAILER_OVERRIDE_REASON_LABEL: "RYTE_ATTACH_TRAILER_OVERRIDE_REASON_LABEL",
  RYTE_ATTACH_TRAILER_OVERRIDE_REASON_PLACEHOLDER:
    "RYTE_ATTACH_TRAILER_OVERRIDE_REASON_PLACEHOLDER",
  RYTE_ATTACH_TRAILER_REASON_NCSL: "RYTE_ATTACH_TRAILER_REASON_NCSL",
  RYTE_ATTACH_TRAILER_REASON_BLOCKED_PUP: "RYTE_ATTACH_TRAILER_REASON_BLOCKED_PUP",
  RYTE_ATTACH_TRAILER_REASON_INCORRECT_LOAD_DATA: "RYTE_ATTACH_TRAILER_REASON_INCORRECT_LOAD_DATA",
  RYTE_ATTACH_TRAILER_REASON_LIVE_LOAD: "RYTE_ATTACH_TRAILER_REASON_LIVE_LOAD",
  RYTE_ATTACH_TRAILER_REASON_PRELOAD: "RYTE_ATTACH_TRAILER_REASON_PRELOAD",
  RYTE_ATTACH_TRAILER_REASON_INCORRECT_TRAILER_DATA:
    "RYTE_ATTACH_TRAILER_REASON_INCORRECT_TRAILER_DATA",
  RYTE_ATTACH_TRAILER_REASON_CASE: "RYTE_ATTACH_TRAILER_REASON_CASE",
  RYTE_ATTACH_TRAILER_LIVE_RECOMMENDATION_NOTICE: "RYTE_ATTACH_TRAILER_LIVE_RECOMMENDATION_NOTICE",
  RYTE_ATTACH_TRAILER_MISSING_IDENTITY: "RYTE_ATTACH_TRAILER_MISSING_IDENTITY",
  RYTE_ATTACH_TRAILER_CONFLICTING_IDENTITY: "RYTE_ATTACH_TRAILER_CONFLICTING_IDENTITY",
  RYTE_ATTACH_TRAILER_RECOMMENDATION_ERROR: "RYTE_ATTACH_TRAILER_RECOMMENDATION_ERROR",
  RYTE_ATTACH_TRAILER_TOO_EARLY: "RYTE_ATTACH_TRAILER_TOO_EARLY",
  RYTE_ATTACH_TRAILER_NONE_AVAILABLE: "RYTE_ATTACH_TRAILER_NONE_AVAILABLE",
  RYTE_ATTACH_TRAILER_REQUEST_NEW: "RYTE_ATTACH_TRAILER_REQUEST_NEW",
  RYTE_TRAILER_ACTION: "RYTE_TRAILER_ACTION",
  RYTE_UNATTACH_TRAILER_ACTION: "RYTE_UNATTACH_TRAILER_ACTION",
  RYTE_UNATTACH_TRAILER_CLOSE: "RYTE_UNATTACH_TRAILER_CLOSE",
  RYTE_UNATTACH_TRAILER_CONFIRMATION: "RYTE_UNATTACH_TRAILER_CONFIRMATION",
  RYTE_UNATTACH_TRAILER_SUCCESS: "RYTE_UNATTACH_TRAILER_SUCCESS",
  RYTE_UNATTACH_TRAILER_SIMULATED_SUCCESS: "RYTE_UNATTACH_TRAILER_SIMULATED_SUCCESS",
  RYTE_UNATTACH_TRAILER_MISSING_LOCATION_PLAN: "RYTE_UNATTACH_TRAILER_MISSING_LOCATION_PLAN",

  // === Cancel VRID Modal ===
  RYTE_MODAL_CANCEL_VRID_TITLE: "RYTE_MODAL_CANCEL_VRID_TITLE",
  RYTE_MODAL_CANCEL_VRID_ALERT: "RYTE_MODAL_CANCEL_VRID_ALERT",
  /**
   * Mid-flight refusal: the yard move behind the goal this dialog would cancel
   * became `EXECUTION_IN_PROGRESS` or `COMPLETED` while the dialog was open, so
   * Confirm is disabled. The action menu refuses the same case up front, so this
   * copy is only ever seen on the race.
   */
  RYTE_MODAL_CANCEL_VRID_MOVE_BLOCKED: "RYTE_MODAL_CANCEL_VRID_MOVE_BLOCKED",
  RYTE_MODAL_CANCEL_VRID_BODY: "RYTE_MODAL_CANCEL_VRID_BODY",
  RYTE_MODAL_CANCEL_VRID_IB_TRANSFER_BODY: "RYTE_MODAL_CANCEL_VRID_IB_TRANSFER_BODY",
  RYTE_MODAL_CANCEL_VRID_IB_TRANSFER_TITLE: "RYTE_MODAL_CANCEL_VRID_IB_TRANSFER_TITLE",
  RYTE_MODAL_CANCEL_VRID_IB_TRANSFER_SUBMIT: "RYTE_MODAL_CANCEL_VRID_IB_TRANSFER_SUBMIT",
  RYTE_MODAL_CANCEL_VRID_IB_TRANSFER_SOURCE_HEADING:
    "RYTE_MODAL_CANCEL_VRID_IB_TRANSFER_SOURCE_HEADING",
  RYTE_MODAL_CANCEL_VRID_IB_TRANSFER_DESTINATION_HEADING:
    "RYTE_MODAL_CANCEL_VRID_IB_TRANSFER_DESTINATION_HEADING",
  RYTE_MODAL_CANCEL_VRID_IB_TRANSFER_DESTINATION_NOTE:
    "RYTE_MODAL_CANCEL_VRID_IB_TRANSFER_DESTINATION_NOTE",
  RYTE_MODAL_CANCEL_VRID_TRAILER: "RYTE_MODAL_CANCEL_VRID_TRAILER",
  RYTE_MODAL_CANCEL_VRID_DOOR: "RYTE_MODAL_CANCEL_VRID_DOOR",
  RYTE_MODAL_CANCEL_VRID_SUBMIT: "RYTE_MODAL_CANCEL_VRID_SUBMIT",
  RYTE_MODAL_CANCEL_VRID_XD_BODY: "RYTE_MODAL_CANCEL_VRID_XD_BODY",
  RYTE_MODAL_CANCEL_VRID_XD_CONFIRM: "RYTE_MODAL_CANCEL_VRID_XD_CONFIRM",
  RYTE_MODAL_CANCEL_VRID_XD_SUCCESS: "RYTE_MODAL_CANCEL_VRID_XD_SUCCESS",
  RYTE_MODAL_CANCEL_VRID_XD_IB_ONLY: "RYTE_MODAL_CANCEL_VRID_XD_IB_ONLY",
  RYTE_MODAL_CANCEL_VRID_XD_OB_ONLY: "RYTE_MODAL_CANCEL_VRID_XD_OB_ONLY",
  RYTE_MODAL_CANCEL_VRID_XD_BOTH_TERMINAL: "RYTE_MODAL_CANCEL_VRID_XD_BOTH_TERMINAL",
  RYTE_MODAL_CANCEL_VRID_XD_PARTIAL_IB_FAILED: "RYTE_MODAL_CANCEL_VRID_XD_PARTIAL_IB_FAILED",
  RYTE_MODAL_CANCEL_VRID_XD_PARTIAL_OB_FAILED: "RYTE_MODAL_CANCEL_VRID_XD_PARTIAL_OB_FAILED",

  // === Release Modal ===
  RYTE_MODAL_RELEASE_TITLE: "RYTE_MODAL_RELEASE_TITLE",
  RYTE_MODAL_RELEASE_BODY: "RYTE_MODAL_RELEASE_BODY",
  RYTE_MODAL_RELEASE_SUBMIT: "RYTE_MODAL_RELEASE_SUBMIT",
  RYTE_MODAL_RELEASE_CHAIN_INFO: "RYTE_MODAL_RELEASE_CHAIN_INFO",
  // Confirm-details card (Trailer / Door / Time at Door) — mirrors the
  // HoldAtDoor card shape.
  RYTE_MODAL_RELEASE_CONFIRM_HEADING: "RYTE_MODAL_RELEASE_CONFIRM_HEADING",
  // TDR-Out acknowledgement checkbox — display-only reminder, does not gate
  // submit, not sent on the wire.
  RYTE_MODAL_RELEASE_TDR_OUT_CONFIRM: "RYTE_MODAL_RELEASE_TDR_OUT_CONFIRM",
  RYTE_MODAL_RELEASE_REASON_LABEL: "RYTE_MODAL_RELEASE_REASON_LABEL",
  RYTE_MODAL_RELEASE_REASON_PLACEHOLDER: "RYTE_MODAL_RELEASE_REASON_PLACEHOLDER",
  RYTE_MODAL_RELEASE_MOVE_TO_LABEL: "RYTE_MODAL_RELEASE_MOVE_TO_LABEL",
  RYTE_MODAL_RELEASE_MOVE_TO_PLACEHOLDER: "RYTE_MODAL_RELEASE_MOVE_TO_PLACEHOLDER",
  RYTE_MODAL_RELEASE_COL_DOOR: "RYTE_MODAL_RELEASE_COL_DOOR",
  RYTE_MODAL_RELEASE_COL_TIME: "RYTE_MODAL_RELEASE_COL_TIME",

  // === Hold & Stage Modal ===
  RYTE_MODAL_HOLD_AND_STAGE_TITLE: "RYTE_MODAL_HOLD_AND_STAGE_TITLE",
  RYTE_MODAL_HOLD_AND_STAGE_ALERT_TITLE: "RYTE_MODAL_HOLD_AND_STAGE_ALERT_TITLE",
  RYTE_MODAL_HOLD_AND_STAGE_ALERT_DESCRIPTION: "RYTE_MODAL_HOLD_AND_STAGE_ALERT_DESCRIPTION",
  RYTE_MODAL_HOLD_AND_STAGE_CONFIRMATION_HEADING: "RYTE_MODAL_HOLD_AND_STAGE_CONFIRMATION_HEADING",
  RYTE_MODAL_HOLD_AND_STAGE_CONFIRMATION_TRAILER: "RYTE_MODAL_HOLD_AND_STAGE_CONFIRMATION_TRAILER",
  RYTE_MODAL_HOLD_AND_STAGE_CONFIRMATION_DOOR: "RYTE_MODAL_HOLD_AND_STAGE_CONFIRMATION_DOOR",
  RYTE_MODAL_HOLD_AND_STAGE_CONFIRMATION_TIME: "RYTE_MODAL_HOLD_AND_STAGE_CONFIRMATION_TIME",
  RYTE_MODAL_HOLD_AND_STAGE_CONFIRMATION_TIME_PENDING:
    "RYTE_MODAL_HOLD_AND_STAGE_CONFIRMATION_TIME_PENDING",
  RYTE_MODAL_HOLD_AND_STAGE_PAUSE_REASON_LABEL: "RYTE_MODAL_HOLD_AND_STAGE_PAUSE_REASON_LABEL",
  RYTE_MODAL_HOLD_AND_STAGE_PAUSE_REASON_PLACEHOLDER:
    "RYTE_MODAL_HOLD_AND_STAGE_PAUSE_REASON_PLACEHOLDER",
  RYTE_MODAL_HOLD_AND_STAGE_START_NOW: "RYTE_MODAL_HOLD_AND_STAGE_START_NOW",
  RYTE_MODAL_HOLD_AND_STAGE_TIME_FROM_LABEL: "RYTE_MODAL_HOLD_AND_STAGE_TIME_FROM_LABEL",
  RYTE_MODAL_HOLD_AND_STAGE_TIME_TO_LABEL: "RYTE_MODAL_HOLD_AND_STAGE_TIME_TO_LABEL",
  RYTE_MODAL_HOLD_AND_STAGE_TIME_WINDOW_HEADING: "RYTE_MODAL_HOLD_AND_STAGE_TIME_WINDOW_HEADING",
  RYTE_MODAL_HOLD_AND_STAGE_SUBMIT_TO: "RYTE_MODAL_HOLD_AND_STAGE_SUBMIT_TO",
  RYTE_MODAL_HOLD_AND_STAGE_DESTINATION_LABEL: "RYTE_MODAL_HOLD_AND_STAGE_DESTINATION_LABEL",
  RYTE_MODAL_HOLD_AND_STAGE_STAGE_TO_DD: "RYTE_MODAL_HOLD_AND_STAGE_STAGE_TO_DD",
  RYTE_MODAL_HOLD_AND_STAGE_STAGE_TO_PS: "RYTE_MODAL_HOLD_AND_STAGE_STAGE_TO_PS",
  RYTE_MODAL_HOLD_AND_STAGE_DD_LABEL: "RYTE_MODAL_HOLD_AND_STAGE_DD_LABEL",
  RYTE_MODAL_HOLD_AND_STAGE_DD_PLACEHOLDER: "RYTE_MODAL_HOLD_AND_STAGE_DD_PLACEHOLDER",
  RYTE_MODAL_HOLD_AND_STAGE_PS_LABEL: "RYTE_MODAL_HOLD_AND_STAGE_PS_LABEL",
  RYTE_MODAL_HOLD_AND_STAGE_PS_PLACEHOLDER: "RYTE_MODAL_HOLD_AND_STAGE_PS_PLACEHOLDER",
  RYTE_MODAL_HOLD_AND_STAGE_PAUSE_AT_CURRENT: "RYTE_MODAL_HOLD_AND_STAGE_PAUSE_AT_CURRENT",
  RYTE_MODAL_HOLD_AND_STAGE_PAUSE_UNTIL_LABEL: "RYTE_MODAL_HOLD_AND_STAGE_PAUSE_UNTIL_LABEL",
  RYTE_MODAL_HOLD_AND_STAGE_PAUSE_UNTIL_BEFORE_NOW:
    "RYTE_MODAL_HOLD_AND_STAGE_PAUSE_UNTIL_BEFORE_NOW",
  RYTE_MODAL_HOLD_AND_STAGE_TIME_END_BEFORE_START:
    "RYTE_MODAL_HOLD_AND_STAGE_TIME_END_BEFORE_START",
  RYTE_MODAL_HOLD_AND_STAGE_TIME_BEYOND_RANGE: "RYTE_MODAL_HOLD_AND_STAGE_TIME_BEYOND_RANGE",
  RYTE_MODAL_HOLD_AND_STAGE_REMOVE_IN_PROGRESS: "RYTE_MODAL_HOLD_AND_STAGE_REMOVE_IN_PROGRESS",
  // ⚠ STILL LIVE despite the KEEP_AT_DOOR prefix — these two are the inline
  // TimeSelect error messages rendered by `HoldAtDoorModal` (Gap 3 before-now,
  // Gap 4 before-existing-start). `KeepAtDoorModal` was deleted 2026-08-19 and
  // its own 11 `RYTE_MODAL_KEEP_AT_DOOR_*` keys went with it, so these two are
  // all that carries the prefix now — a prefix-based sweep would hit only live
  // messages. Rename them to HOLD_AT_DOOR only together with the locale bundles
  // in the same commit.
  RYTE_MODAL_KEEP_AT_DOOR_TIME_BEFORE_NOW: "RYTE_MODAL_KEEP_AT_DOOR_TIME_BEFORE_NOW",
  RYTE_MODAL_KEEP_AT_DOOR_TIME_BEFORE_EXISTING_START:
    "RYTE_MODAL_KEEP_AT_DOOR_TIME_BEFORE_EXISTING_START",
  RYTE_MODAL_HOLD_AND_STAGE_SUBMIT: "RYTE_MODAL_HOLD_AND_STAGE_SUBMIT",
  RYTE_MODAL_HOLD_AND_STAGE_SUCCESS: "RYTE_MODAL_HOLD_AND_STAGE_SUCCESS",
  RYTE_MODAL_HOLD_AND_STAGE_ERROR_CREATE_REMOVE_SOURCE:
    "RYTE_MODAL_HOLD_AND_STAGE_ERROR_CREATE_REMOVE_SOURCE",
  RYTE_MODAL_HOLD_AND_STAGE_ERROR_CREATE_LOAD_DESTINATION:
    "RYTE_MODAL_HOLD_AND_STAGE_ERROR_CREATE_LOAD_DESTINATION",
  RYTE_MODAL_HOLD_AND_STAGE_ERROR_CREATE_REMOVE_DESTINATION:
    "RYTE_MODAL_HOLD_AND_STAGE_ERROR_CREATE_REMOVE_DESTINATION",

  // === Flip Trailer to OB Modal === (reuse the inbound trailer for an
  // outbound VRID — builds an XD chain off the puck's UNLOAD via the
  // shared `useOptimisticXdChain` hook.)
  RYTE_MODAL_FLIP_TRAILER_TO_OB_TITLE: "RYTE_MODAL_FLIP_TRAILER_TO_OB_TITLE",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_ALERT: "RYTE_MODAL_FLIP_TRAILER_TO_OB_ALERT",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_INBOUND: "RYTE_MODAL_FLIP_TRAILER_TO_OB_INBOUND",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_DOOR: "RYTE_MODAL_FLIP_TRAILER_TO_OB_DOOR",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_CPT: "RYTE_MODAL_FLIP_TRAILER_TO_OB_CPT",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_OUTBOUND: "RYTE_MODAL_FLIP_TRAILER_TO_OB_OUTBOUND",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_DESTINATION: "RYTE_MODAL_FLIP_TRAILER_TO_OB_DESTINATION",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_CUT_TIME: "RYTE_MODAL_FLIP_TRAILER_TO_OB_CUT_TIME",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_SELECT_LABEL: "RYTE_MODAL_FLIP_TRAILER_TO_OB_SELECT_LABEL",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_SELECT_PLACEHOLDER:
    "RYTE_MODAL_FLIP_TRAILER_TO_OB_SELECT_PLACEHOLDER",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_SUBMIT: "RYTE_MODAL_FLIP_TRAILER_TO_OB_SUBMIT",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_PLANNED_SUFFIX: "RYTE_MODAL_FLIP_TRAILER_TO_OB_PLANNED_SUFFIX",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_UPDATE_DISABLED: "RYTE_MODAL_FLIP_TRAILER_TO_OB_UPDATE_DISABLED",
  RYTE_MODAL_FLIP_TRAILER_TO_OB_CANDIDATE_STALE: "RYTE_MODAL_FLIP_TRAILER_TO_OB_CANDIDATE_STALE",

  // === Hold at Door Modal === (simple hold-at-current-door; reuses Keep at
  // Door wire paths — open-ended → cancel REMOVE, specific → update/create
  // REMOVE — with a confirm-details presentation. No destination picker.)
  RYTE_MODAL_HOLD_AT_DOOR_TITLE: "RYTE_MODAL_HOLD_AT_DOOR_TITLE",
  RYTE_MODAL_HOLD_AT_DOOR_INFO: "RYTE_MODAL_HOLD_AT_DOOR_INFO",
  RYTE_MODAL_HOLD_AT_DOOR_CONFIRM_HEADING: "RYTE_MODAL_HOLD_AT_DOOR_CONFIRM_HEADING",
  RYTE_MODAL_HOLD_AT_DOOR_COL_DOOR: "RYTE_MODAL_HOLD_AT_DOOR_COL_DOOR",
  RYTE_MODAL_HOLD_AT_DOOR_COL_TIME: "RYTE_MODAL_HOLD_AT_DOOR_COL_TIME",
  RYTE_MODAL_HOLD_AT_DOOR_DURATION_LABEL: "RYTE_MODAL_HOLD_AT_DOOR_DURATION_LABEL",
  RYTE_MODAL_HOLD_AT_DOOR_OPEN_ENDED: "RYTE_MODAL_HOLD_AT_DOOR_OPEN_ENDED",
  RYTE_MODAL_HOLD_AT_DOOR_OPEN_ENDED_ALREADY: "RYTE_MODAL_HOLD_AT_DOOR_OPEN_ENDED_ALREADY",
  /**
   * Open-ended hold refused on a STANDALONE REMOVE puck (matrix Section D): the
   * branch's `requestCancelGoal` would target the puck's only goal, making it a
   * duplicate of Cancel Plan. Points the operator at Cancel Plan rather than
   * explaining the collision.
   */
  RYTE_MODAL_HOLD_AT_DOOR_OPEN_ENDED_USE_CANCEL: "RYTE_MODAL_HOLD_AT_DOOR_OPEN_ENDED_USE_CANCEL",
  /**
   * Open-ended radio disabled because cancelling this removal would cascade —
   * `resolveGoalDependents` returned `"present"` or `"unknown"`. Distinct from
   * `_OPEN_ENDED_ALREADY`, which is the no-op ("already indefinite") notice.
   */
  RYTE_MODAL_HOLD_AT_DOOR_OPEN_ENDED_DEPENDENTS: "RYTE_MODAL_HOLD_AT_DOOR_OPEN_ENDED_DEPENDENTS",
  RYTE_MODAL_HOLD_AT_DOOR_SPECIFIC: "RYTE_MODAL_HOLD_AT_DOOR_SPECIFIC",
  /**
   * Specific-time radio disabled: the removal is past the point the engine will
   * reschedule it AND it cannot be safely replaced (XD-chain leg, or a live
   * dependent exists / cannot be determined).
   */
  RYTE_MODAL_HOLD_AT_DOOR_SPECIFIC_NO_PATH: "RYTE_MODAL_HOLD_AT_DOOR_SPECIFIC_NO_PATH",
  /**
   * Modal-local backstop copy: the REMOVE's move is `EXECUTION_IN_PROGRESS`, so
   * both duration branches are refused. Production reaches this only through a
   * WS move update arriving while the modal sits open — the menu's own gate
   * (`RYTE_PUCK_ACTION_HOLD_AND_STAGE_DISABLED_MOVE_IN_PROGRESS`) keeps it
   * unreachable on open.
   */
  RYTE_MODAL_HOLD_AT_DOOR_MOVE_IN_PROGRESS: "RYTE_MODAL_HOLD_AT_DOOR_MOVE_IN_PROGRESS",
  /**
   * ACTIVE-replacement alert body — the removal is already underway.
   *
   * Now shown ONLY when the move state is UNKNOWN (`resolveRemoveMoveState`), so
   * the warning fires where certainty was lost rather than on every `ACTIVE`
   * REMOVE. A move proven `SCHEDULED` retracts nothing physical and gets no
   * alert; a move proven `EXECUTION_IN_PROGRESS` is blocked outright above.
   */
  RYTE_MODAL_HOLD_AT_DOOR_REPLACE_ACTIVE_ALERT: "RYTE_MODAL_HOLD_AT_DOOR_REPLACE_ACTIVE_ALERT",
  /** ACTIVE-replacement acknowledgement checkbox label (gates Confirm). */
  RYTE_MODAL_HOLD_AT_DOOR_REPLACE_ACTIVE_ACK: "RYTE_MODAL_HOLD_AT_DOOR_REPLACE_ACTIVE_ACK",
  /**
   * Replacement partial failure — the new removal was created but the original
   * could not be cancelled, so TWO live REMOVEs now exist on one trailer
   * (cross-cutting invariant #7). MessageVars: { id, door }.
   */
  RYTE_MODAL_HOLD_AT_DOOR_REPLACE_PARTIAL_FAILURE:
    "RYTE_MODAL_HOLD_AT_DOOR_REPLACE_PARTIAL_FAILURE",
  RYTE_MODAL_HOLD_AT_DOOR_TIME_WINDOW_LABEL: "RYTE_MODAL_HOLD_AT_DOOR_TIME_WINDOW_LABEL",
  RYTE_MODAL_HOLD_AT_DOOR_TIME_UNTIL_LABEL: "RYTE_MODAL_HOLD_AT_DOOR_TIME_UNTIL_LABEL",
  RYTE_MODAL_HOLD_AT_DOOR_FOOTER_HINT: "RYTE_MODAL_HOLD_AT_DOOR_FOOTER_HINT",
  RYTE_MODAL_HOLD_AT_DOOR_SUBMIT: "RYTE_MODAL_HOLD_AT_DOOR_SUBMIT",
  RYTE_MODAL_HOLD_AT_DOOR_SUCCESS: "RYTE_MODAL_HOLD_AT_DOOR_SUCCESS",
  RYTE_MODAL_HOLD_AT_DOOR_ERROR: "RYTE_MODAL_HOLD_AT_DOOR_ERROR",
  RYTE_MODAL_HOLD_AT_DOOR_CHAIN_INFO: "RYTE_MODAL_HOLD_AT_DOOR_CHAIN_INFO",

  // === Queue-card Actions + Hold at Door (create-mode) ===
  // A queue card is UNPLANNED demand (no puck/goal). "Hold at Door" PLANS it
  // onto a chosen direction-compatible door (Primary LOAD/UNLOAD) AND holds it
  // (chained REMOVE) in one paired create — distinct from the puck-side
  // HoldAtDoorModal, which assumes an existing LOAD.
  RYTE_CARD_ACTIONS: "RYTE_CARD_ACTIONS",
  RYTE_CARD_ACTION_HOLD_AT_DOOR: "RYTE_CARD_ACTION_HOLD_AT_DOOR",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_TITLE: "RYTE_MODAL_CARD_HOLD_AT_DOOR_TITLE",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_INFO: "RYTE_MODAL_CARD_HOLD_AT_DOOR_INFO",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_CONFIRM_HEADING: "RYTE_MODAL_CARD_HOLD_AT_DOOR_CONFIRM_HEADING",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_COL_LOAD_ID: "RYTE_MODAL_CARD_HOLD_AT_DOOR_COL_LOAD_ID",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_COL_TRAILER: "RYTE_MODAL_CARD_HOLD_AT_DOOR_COL_TRAILER",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_COL_LOCATION: "RYTE_MODAL_CARD_HOLD_AT_DOOR_COL_LOCATION",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_COL_TIME: "RYTE_MODAL_CARD_HOLD_AT_DOOR_COL_TIME",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_DOOR_LABEL: "RYTE_MODAL_CARD_HOLD_AT_DOOR_DOOR_LABEL",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_DOOR_PLACEHOLDER: "RYTE_MODAL_CARD_HOLD_AT_DOOR_DOOR_PLACEHOLDER",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_LABEL: "RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_LABEL",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_HELPER: "RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_HELPER",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_FROM: "RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_FROM",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_TO: "RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_TO",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_BEFORE_NOW: "RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_BEFORE_NOW",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_TO_BEFORE_FROM:
    "RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_TO_BEFORE_FROM",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_TO_BEYOND_RANGE:
    "RYTE_MODAL_CARD_HOLD_AT_DOOR_TIME_TO_BEYOND_RANGE",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_FOOTER_HINT: "RYTE_MODAL_CARD_HOLD_AT_DOOR_FOOTER_HINT",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_SUBMIT: "RYTE_MODAL_CARD_HOLD_AT_DOOR_SUBMIT",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_SUCCESS: "RYTE_MODAL_CARD_HOLD_AT_DOOR_SUCCESS",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_ERROR: "RYTE_MODAL_CARD_HOLD_AT_DOOR_ERROR",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_PARTIAL_FAILURE: "RYTE_MODAL_CARD_HOLD_AT_DOOR_PARTIAL_FAILURE",
  RYTE_MODAL_CARD_HOLD_AT_DOOR_CREATE_DISABLED: "RYTE_MODAL_CARD_HOLD_AT_DOOR_CREATE_DISABLED",

  // === Manual Move Modal ===
  RYTE_MODAL_MANUAL_MOVE_TITLE: "RYTE_MODAL_MANUAL_MOVE_TITLE",
  RYTE_MODAL_MANUAL_MOVE_BODY: "RYTE_MODAL_MANUAL_MOVE_BODY",
  RYTE_MODAL_MANUAL_MOVE_TDR_HINT: "RYTE_MODAL_MANUAL_MOVE_TDR_HINT",
  RYTE_MODAL_MANUAL_MOVE_REASON_LABEL: "RYTE_MODAL_MANUAL_MOVE_REASON_LABEL",
  RYTE_MODAL_MANUAL_MOVE_REASON_PLACEHOLDER: "RYTE_MODAL_MANUAL_MOVE_REASON_PLACEHOLDER",
  RYTE_MODAL_MANUAL_MOVE_SUBMIT: "RYTE_MODAL_MANUAL_MOVE_SUBMIT",
  RYTE_MODAL_MANUAL_MOVE_SUCCESS: "RYTE_MODAL_MANUAL_MOVE_SUCCESS",
  RYTE_MODAL_MANUAL_MOVE_ERROR: "RYTE_MODAL_MANUAL_MOVE_ERROR",

  // === Unlink Cross-Dock action toasts ===
  RYTE_MODAL_UNLINK_CROSS_DOCK_SUCCESS: "RYTE_MODAL_UNLINK_CROSS_DOCK_SUCCESS",
  RYTE_MODAL_UNLINK_CROSS_DOCK_ERROR: "RYTE_MODAL_UNLINK_CROSS_DOCK_ERROR",

  // === Action Reasons === (consumed by `actionReasons.ts`; sent to backend
  // as `reasonCode` per matrix Q2). Backend-driven source deferred (Q1).
  RYTE_STAGE_REASON_EQUIPMENT_ISSUE: "RYTE_STAGE_REASON_EQUIPMENT_ISSUE",
  RYTE_STAGE_REASON_CAPACITY_CONSTRAINT: "RYTE_STAGE_REASON_CAPACITY_CONSTRAINT",
  RYTE_STAGE_REASON_MISSING_PAPERWORK: "RYTE_STAGE_REASON_MISSING_PAPERWORK",
  RYTE_STAGE_REASON_PRIORITY_OVERRIDE: "RYTE_STAGE_REASON_PRIORITY_OVERRIDE",
  RYTE_STAGE_REASON_WEATHER_HOLD: "RYTE_STAGE_REASON_WEATHER_HOLD",
  RYTE_STAGE_REASON_INSPECTION_REQUIRED: "RYTE_STAGE_REASON_INSPECTION_REQUIRED",
  RYTE_STAGE_REASON_SHIFT_CHANGE: "RYTE_STAGE_REASON_SHIFT_CHANGE",
  RYTE_REMOVAL_REASON_TRAILER_NOT_NEEDED: "RYTE_REMOVAL_REASON_TRAILER_NOT_NEEDED",
  RYTE_REMOVAL_REASON_WRONG_TRAILER: "RYTE_REMOVAL_REASON_WRONG_TRAILER",
  RYTE_REMOVAL_REASON_DOOR_NEEDED: "RYTE_REMOVAL_REASON_DOOR_NEEDED",
  RYTE_REMOVAL_REASON_TRAILER_ISSUE: "RYTE_REMOVAL_REASON_TRAILER_ISSUE",
  RYTE_REMOVAL_REASON_CARRIER_REQUESTED: "RYTE_REMOVAL_REASON_CARRIER_REQUESTED",
  RYTE_REMOVAL_REASON_OTHER: "RYTE_REMOVAL_REASON_OTHER",

  // === Shared (across all modals) ===
  RYTE_MODAL_GO_BACK: "RYTE_MODAL_GO_BACK",
  // Confirmation-card column headers shared by every action modal's gray
  // summary box (Load Id = demand-id; Trailer = physical plate/equipment#).
  RYTE_MODAL_COL_LOAD_ID: "RYTE_MODAL_COL_LOAD_ID",
  RYTE_MODAL_COL_TRAILER: "RYTE_MODAL_COL_TRAILER",

  // Early-schedule confirmation modal (drop when equipment not yet in yard)
  RYTE_MODAL_EARLY_SCHEDULE_TITLE: "RYTE_MODAL_EARLY_SCHEDULE_TITLE",
  RYTE_MODAL_EARLY_SCHEDULE_ALERT: "RYTE_MODAL_EARLY_SCHEDULE_ALERT",
  RYTE_MODAL_EARLY_SCHEDULE_DOOR: "RYTE_MODAL_EARLY_SCHEDULE_DOOR",
  RYTE_MODAL_EARLY_SCHEDULE_START: "RYTE_MODAL_EARLY_SCHEDULE_START",
  RYTE_MODAL_EARLY_SCHEDULE_ETA: "RYTE_MODAL_EARLY_SCHEDULE_ETA",
  RYTE_MODAL_EARLY_SCHEDULE_SUBMIT: "RYTE_MODAL_EARLY_SCHEDULE_SUBMIT",

  // Queue toggle
  RYTE_QUEUE_TOGGLE_INBOUND: "RYTE_QUEUE_TOGGLE_INBOUND",
  RYTE_QUEUE_TOGGLE_OUTBOUND: "RYTE_QUEUE_TOGGLE_OUTBOUND",

  // Enriched puck detail panel
  RYTE_ENRICHED_CARRIER_CODE: "RYTE_ENRICHED_CARRIER_CODE",
  RYTE_ENRICHED_OWNER: "RYTE_ENRICHED_OWNER",
  RYTE_ENRICHED_TRAILER: "RYTE_ENRICHED_TRAILER",
  RYTE_ENRICHED_TRAILER_TYPE: "RYTE_ENRICHED_TRAILER_TYPE",
  RYTE_ENRICHED_DWELL_TIME: "RYTE_ENRICHED_DWELL_TIME",
  RYTE_ENRICHED_APPOINTMENT_ARRIVAL: "RYTE_ENRICHED_APPOINTMENT_ARRIVAL",
  RYTE_ENRICHED_ARRIVAL_EARLY: "RYTE_ENRICHED_ARRIVAL_EARLY",
  RYTE_ENRICHED_ARRIVAL_LATE: "RYTE_ENRICHED_ARRIVAL_LATE",

  // Event list
  RYTE_EVENT_LIST_HEADING: "RYTE_EVENT_LIST_HEADING",

  // Mock data generator
  RYTE_MOCK_DATA_BUTTON: "RYTE_MOCK_DATA_BUTTON",
  RYTE_MOCK_MODAL_TITLE: "RYTE_MOCK_MODAL_TITLE",
  RYTE_MOCK_NO_SITE: "RYTE_MOCK_NO_SITE",
  RYTE_MOCK_ERROR: "RYTE_MOCK_ERROR",
  RYTE_MOCK_ROUTE_ERROR: "RYTE_MOCK_ROUTE_ERROR",
  RYTE_MOCK_SCENARIO_INFO: "RYTE_MOCK_SCENARIO_INFO",
  RYTE_MOCK_WS_UPDATES_HEADING: "RYTE_MOCK_WS_UPDATES_HEADING",
  RYTE_MOCK_WS_UPDATES_DESCRIPTION: "RYTE_MOCK_WS_UPDATES_DESCRIPTION",
  RYTE_MOCK_WS_UPDATES_START: "RYTE_MOCK_WS_UPDATES_START",
  RYTE_MOCK_WS_UPDATES_STOP: "RYTE_MOCK_WS_UPDATES_STOP",
  RYTE_MOCK_WS_UPDATES_NEEDS_DATA: "RYTE_MOCK_WS_UPDATES_NEEDS_DATA",

  // Event type labels
  RYTE_EVENT_TYPE_TDR_DOCK: "RYTE_EVENT_TYPE_TDR_DOCK",
  RYTE_EVENT_TYPE_TDR_RELEASE: "RYTE_EVENT_TYPE_TDR_RELEASE",
  RYTE_EVENT_TYPE_IB_DOCK_COMPLETED: "RYTE_EVENT_TYPE_IB_DOCK_COMPLETED",
  RYTE_EVENT_TYPE_IB_DOCK_STARTED: "RYTE_EVENT_TYPE_IB_DOCK_STARTED",
  RYTE_EVENT_TYPE_OB_DOCK_COMPLETED: "RYTE_EVENT_TYPE_OB_DOCK_COMPLETED",
  RYTE_EVENT_TYPE_OB_DOCK_STARTED: "RYTE_EVENT_TYPE_OB_DOCK_STARTED",
  RYTE_EVENT_TYPE_MOVE_SELF: "RYTE_EVENT_TYPE_MOVE_SELF",
  RYTE_EVENT_TYPE_MOVE_BY_TRACTOR: "RYTE_EVENT_TYPE_MOVE_BY_TRACTOR",
  RYTE_EVENT_TYPE_MOVE_BY_HOSTLER: "RYTE_EVENT_TYPE_MOVE_BY_HOSTLER",
  RYTE_EVENT_TYPE_HOSTLER_CANCEL: "RYTE_EVENT_TYPE_HOSTLER_CANCEL",
  RYTE_EVENT_TYPE_HOSTLER_CREATE: "RYTE_EVENT_TYPE_HOSTLER_CREATE",
  RYTE_EVENT_TYPE_HOSTLER_COMPLETE: "RYTE_EVENT_TYPE_HOSTLER_COMPLETE",
  RYTE_EVENT_TYPE_HOSTLER_RELEASE: "RYTE_EVENT_TYPE_HOSTLER_RELEASE",
  RYTE_EVENT_TYPE_HOSTLER_REORDER: "RYTE_EVENT_TYPE_HOSTLER_REORDER",
  RYTE_EVENT_TYPE_HOSTLER_RESERVE: "RYTE_EVENT_TYPE_HOSTLER_RESERVE",
  RYTE_EVENT_TYPE_HOSTLER_START: "RYTE_EVENT_TYPE_HOSTLER_START",

  // Accessibility
  RYTE_VIEW_ARIA_LABEL: "RYTE_VIEW_ARIA_LABEL",

  // Toolbar enhancements
  RYTE_TOOLBAR_VIEW_HOURS: "RYTE_TOOLBAR_VIEW_HOURS",
  RYTE_TOOLBAR_REFRESH: "RYTE_TOOLBAR_REFRESH",
  RYTE_TOOLBAR_DOWNLOAD: "RYTE_TOOLBAR_DOWNLOAD",

  // Chart filters
  RYTE_FILTER_VIEW: "RYTE_FILTER_VIEW",
  RYTE_FILTER_ALL_DOORS: "RYTE_FILTER_ALL_DOORS",
  RYTE_FILTER_IB_ONLY: "RYTE_FILTER_IB_ONLY",
  RYTE_FILTER_OB_ONLY: "RYTE_FILTER_OB_ONLY",
  RYTE_FILTER_DOOR_TYPE_LEGEND: "RYTE_FILTER_DOOR_TYPE_LEGEND",
  RYTE_FILTER_INFO: "RYTE_FILTER_INFO",
  RYTE_FILTER_SEARCH_PLACEHOLDER: "RYTE_FILTER_SEARCH_PLACEHOLDER",
  RYTE_FILTER_FILTERS: "RYTE_FILTER_FILTERS",
  RYTE_FILTER_XD: "RYTE_FILTER_XD",
  RYTE_TOOLBAR_JUMP_TO_NOW: "RYTE_TOOLBAR_JUMP_TO_NOW",
  RYTE_TOOLBAR_LEGEND: "RYTE_TOOLBAR_LEGEND",

  // Date navigation cluster (calendar chip + day steppers are decorative /
  // disabled today; the visible-range readout reflects the chart window).
  RYTE_TOOLBAR_TODAY: "RYTE_TOOLBAR_TODAY",
  RYTE_TOOLBAR_CALENDAR_LABEL: "RYTE_TOOLBAR_CALENDAR_LABEL",
  RYTE_TOOLBAR_PREV_DAY: "RYTE_TOOLBAR_PREV_DAY",
  RYTE_TOOLBAR_NEXT_DAY: "RYTE_TOOLBAR_NEXT_DAY",
  RYTE_TOOLBAR_VISIBLE_RANGE: "RYTE_TOOLBAR_VISIBLE_RANGE",
  RYTE_TOOLBAR_VISIBLE_RANGE_EMPTY: "RYTE_TOOLBAR_VISIBLE_RANGE_EMPTY",

  // Legend (info toggle) — section labels
  RYTE_LEGEND_PUCK_STATES_LABEL: "RYTE_LEGEND_PUCK_STATES_LABEL",
  RYTE_LEGEND_TRAILER_TAGS_LABEL: "RYTE_LEGEND_TRAILER_TAGS_LABEL",
  RYTE_LEGEND_PROCESSING_STAGES_LABEL: "RYTE_LEGEND_PROCESSING_STAGES_LABEL",
  RYTE_LEGEND_VARIANCE_LABEL: "RYTE_LEGEND_VARIANCE_LABEL",
  RYTE_LEGEND_GANTT_INDICATORS_LABEL: "RYTE_LEGEND_GANTT_INDICATORS_LABEL",

  // Legend — puck state items
  RYTE_LEGEND_IN_PROGRESS: "RYTE_LEGEND_IN_PROGRESS",
  RYTE_LEGEND_UPCOMING: "RYTE_LEGEND_UPCOMING",
  RYTE_LEGEND_COMPLETE: "RYTE_LEGEND_COMPLETE",

  // Legend — trailer tag chip labels
  RYTE_LEGEND_DROP: "RYTE_LEGEND_DROP",
  RYTE_LEGEND_LIVE: "RYTE_LEGEND_LIVE",
  RYTE_LEGEND_TAG_DRIVER: "RYTE_LEGEND_TAG_DRIVER",
  RYTE_LEGEND_TAG_RED: "RYTE_LEGEND_TAG_RED",
  RYTE_LEGEND_TAG_YLW: "RYTE_LEGEND_TAG_YLW",
  RYTE_LEGEND_TAG_BLUE: "RYTE_LEGEND_TAG_BLUE",
  RYTE_LEGEND_TAG_HSTLR: "RYTE_LEGEND_TAG_HSTLR",
  RYTE_LEGEND_TAG_XD: "RYTE_LEGEND_TAG_XD",
  RYTE_LEGEND_TAG_NOT_ATTACHED: "RYTE_LEGEND_TAG_NOT_ATTACHED",

  // Legend — processing stage items
  RYTE_LEGEND_PENDING: "RYTE_LEGEND_PENDING",
  RYTE_LEGEND_HOSTLER_CREATE: "RYTE_LEGEND_HOSTLER_CREATE",
  RYTE_LEGEND_TDR_IN: "RYTE_LEGEND_TDR_IN",
  RYTE_LEGEND_PROCESSING_STAGE: "RYTE_LEGEND_PROCESSING_STAGE",
  RYTE_LEGEND_TDR_OUT: "RYTE_LEGEND_TDR_OUT",
  RYTE_LEGEND_HOSTLER_REMOVE: "RYTE_LEGEND_HOSTLER_REMOVE",
  RYTE_LEGEND_COMPLETED_STAGE: "RYTE_LEGEND_COMPLETED_STAGE",

  // Legend — variance pill labels (static)
  RYTE_LEGEND_VARIANCE_EARLY: "RYTE_LEGEND_VARIANCE_EARLY",
  RYTE_LEGEND_VARIANCE_LATE: "RYTE_LEGEND_VARIANCE_LATE",

  // Legend — gantt indicator labels
  RYTE_LEGEND_CURRENT_TIME: "RYTE_LEGEND_CURRENT_TIME",
  RYTE_LEGEND_DROP_MARKER: "RYTE_LEGEND_DROP_MARKER",

  // Door filter popover
  RYTE_DOOR_FILTER_TITLE: "RYTE_DOOR_FILTER_TITLE",
  RYTE_DOOR_FILTER_CLOSE: "RYTE_DOOR_FILTER_CLOSE",
  RYTE_DOOR_FILTER_EMPTY_LIST: "RYTE_DOOR_FILTER_EMPTY_LIST",
  RYTE_DOOR_FILTER_CLEAR_ALL: "RYTE_DOOR_FILTER_CLEAR_ALL",
  RYTE_DOOR_FILTER_SELECT_ALL: "RYTE_DOOR_FILTER_SELECT_ALL",
  RYTE_DOOR_FILTER_DOORS_HEADER: "RYTE_DOOR_FILTER_DOORS_HEADER",
  RYTE_DOOR_FILTER_LIST_PLACEHOLDER: "RYTE_DOOR_FILTER_LIST_PLACEHOLDER",
  RYTE_DOOR_FILTER_CLEAR_LIST: "RYTE_DOOR_FILTER_CLEAR_LIST",
  RYTE_DOOR_FILTER_ADD: "RYTE_DOOR_FILTER_ADD",
  RYTE_DOOR_FILTER_RANGE_HINT: "RYTE_DOOR_FILTER_RANGE_HINT",
  RYTE_DOCK_TYPE_XD: "RYTE_DOCK_TYPE_XD",

  // Queue filter popover (replaces the Sort dropdown)
  RYTE_QUEUE_FILTER_BUTTON: "RYTE_QUEUE_FILTER_BUTTON",
  RYTE_QUEUE_FILTER_TITLE: "RYTE_QUEUE_FILTER_TITLE",
  RYTE_QUEUE_FILTER_CLOSE: "RYTE_QUEUE_FILTER_CLOSE",
  RYTE_QUEUE_FILTER_CLEAR_ALL: "RYTE_QUEUE_FILTER_CLEAR_ALL",
  RYTE_QUEUE_FILTER_DONE: "RYTE_QUEUE_FILTER_DONE",
  RYTE_QUEUE_FILTER_SORT_BY: "RYTE_QUEUE_FILTER_SORT_BY",
  RYTE_QUEUE_FILTER_PRIORITY: "RYTE_QUEUE_FILTER_PRIORITY",
  RYTE_QUEUE_FILTER_OPERATOR: "RYTE_QUEUE_FILTER_OPERATOR",
  RYTE_QUEUE_FILTER_LOAD_STATUS: "RYTE_QUEUE_FILTER_LOAD_STATUS",
  RYTE_QUEUE_FILTER_OWNER: "RYTE_QUEUE_FILTER_OWNER",
  RYTE_QUEUE_FILTER_EMPTY: "RYTE_QUEUE_FILTER_EMPTY",

  // Cross Dock Assignment modal (Phase 2.1)
  RYTE_XD_MODAL_TITLE: "RYTE_XD_MODAL_TITLE",
  RYTE_XD_MODAL_BANNER: "RYTE_XD_MODAL_BANNER",
  RYTE_XD_MODAL_BANNER_TEXT: "RYTE_XD_MODAL_BANNER_TEXT",
  RYTE_XD_MODAL_CONFIRMATION_HEADING: "RYTE_XD_MODAL_CONFIRMATION_HEADING",
  RYTE_XD_MODAL_CONFIRMATION_SUB: "RYTE_XD_MODAL_CONFIRMATION_SUB",
  RYTE_XD_MODAL_INBOUND: "RYTE_XD_MODAL_INBOUND",
  RYTE_XD_MODAL_OUTBOUND: "RYTE_XD_MODAL_OUTBOUND",
  RYTE_XD_MODAL_TRAILER: "RYTE_XD_MODAL_TRAILER",
  RYTE_XD_MODAL_DOOR: "RYTE_XD_MODAL_DOOR",
  RYTE_XD_MODAL_UNLOAD_COMPLETE: "RYTE_XD_MODAL_UNLOAD_COMPLETE",
  RYTE_XD_MODAL_OB_START: "RYTE_XD_MODAL_OB_START",
  RYTE_XD_MODAL_DESTINATION: "RYTE_XD_MODAL_DESTINATION",
  RYTE_XD_MODAL_FOOTER_NOTE: "RYTE_XD_MODAL_FOOTER_NOTE",
  RYTE_XD_MODAL_FOOTER_NOTE_NO_CANCEL: "RYTE_XD_MODAL_FOOTER_NOTE_NO_CANCEL",
  RYTE_XD_MODAL_CANCEL: "RYTE_XD_MODAL_CANCEL",
  RYTE_XD_MODAL_CONFIRM: "RYTE_XD_MODAL_CONFIRM",
  RYTE_XD_MODAL_DEST_UNKNOWN: "RYTE_XD_MODAL_DEST_UNKNOWN",
  RYTE_XD_CHAIN_SUCCESS: "RYTE_XD_CHAIN_SUCCESS",
  RYTE_XD_CREATE_DISABLED: "RYTE_XD_CREATE_DISABLED",
  RYTE_XD_LOAD_FAILED: "RYTE_XD_LOAD_FAILED",
  RYTE_XD_PARTIAL_FAILURE: "RYTE_XD_PARTIAL_FAILURE",
  RYTE_XD_CANCEL_FAILED: "RYTE_XD_CANCEL_FAILED",
  // Multi-cancel partial-failure key (`cross-dock-cancel-parallelization`
  // R3). Surfaces when the concurrent cancel batch had ≥1 failure;
  // names the canceled vs failed goalIds so the operator can decide
  // what manual recovery is needed. Single-cancel paths keep
  // RYTE_XD_CANCEL_FAILED for backwards-compat.
  RYTE_XD_CANCELS_PARTIAL_FAILED: "RYTE_XD_CANCELS_PARTIAL_FAILED",
  RYTE_XD_LOAD_FAILED_AFTER_CANCEL: "RYTE_XD_LOAD_FAILED_AFTER_CANCEL",
  // Classifier reject reasons (v2 — F2 wiring). Matched 1:1 to
  // XdRejectReason values produced by validateXdDrop.
  RYTE_XD_REJECT_DOOR_TYPE: "RYTE_XD_REJECT_DOOR_TYPE",
  RYTE_XD_REJECT_TARGET_NOT_UNLOAD: "RYTE_XD_REJECT_TARGET_NOT_UNLOAD",
  RYTE_XD_REJECT_UNLOAD_TERMINAL: "RYTE_XD_REJECT_UNLOAD_TERMINAL",
  RYTE_XD_REJECT_TIME_OVERLAP: "RYTE_XD_REJECT_TIME_OVERLAP",
  // Source-side reject reasons for puck-to-puck XD flow
  // (`cross-dock-from-existing-load` VS1–VS4).
  RYTE_XD_REJECT_SOURCE_NOT_LOAD: "RYTE_XD_REJECT_SOURCE_NOT_LOAD",
  RYTE_XD_REJECT_SOURCE_NOT_CREATED: "RYTE_XD_REJECT_SOURCE_NOT_CREATED",
  RYTE_XD_REJECT_SOURCE_SAME_VISIT: "RYTE_XD_REJECT_SOURCE_SAME_VISIT",
  // Conditional subtitle for the puck-to-puck XD flow
  // (`cross-dock-from-existing-load` T5 / KDD-6). Rendered in the
  // CrossDockAssignmentModal only when `pending.source` is populated.
  // Carries `{sourceLabel, targetLabel}` interpolation tokens.
  RYTE_XD_FROM_LOAD_SUBTITLE: "RYTE_XD_FROM_LOAD_SUBTITLE",

  // === Goalless TDR Cycle Reference Puck ===
  RYTE_GOALLESS_TDR_TOOLTIP_TITLE: "RYTE_GOALLESS_TDR_TOOLTIP_TITLE",
  RYTE_GOALLESS_TDR_TOOLTIP_EQUIPMENT: "RYTE_GOALLESS_TDR_TOOLTIP_EQUIPMENT",
  RYTE_GOALLESS_TDR_TOOLTIP_VISIT: "RYTE_GOALLESS_TDR_TOOLTIP_VISIT",
  RYTE_GOALLESS_TDR_TOOLTIP_DOOR: "RYTE_GOALLESS_TDR_TOOLTIP_DOOR",
  RYTE_GOALLESS_TDR_TOOLTIP_DIRECTION: "RYTE_GOALLESS_TDR_TOOLTIP_DIRECTION",
  RYTE_GOALLESS_TDR_TOOLTIP_DURATION: "RYTE_GOALLESS_TDR_TOOLTIP_DURATION",
  RYTE_GOALLESS_TDR_TOOLTIP_FOOTER: "RYTE_GOALLESS_TDR_TOOLTIP_FOOTER",
  RYTE_GOALLESS_TDR_PUCK_ARIA_LABEL: "RYTE_GOALLESS_TDR_PUCK_ARIA_LABEL",
  RYTE_GOALLESS_TDR_TOOLTIP_TITLE_ACTIVE: "RYTE_GOALLESS_TDR_TOOLTIP_TITLE_ACTIVE",
  RYTE_GOALLESS_TDR_TOOLTIP_FOOTER_ACTIVE: "RYTE_GOALLESS_TDR_TOOLTIP_FOOTER_ACTIVE",
  RYTE_GOALLESS_TDR_TOOLTIP_DURATION_ACTIVE: "RYTE_GOALLESS_TDR_TOOLTIP_DURATION_ACTIVE",
  RYTE_GOALLESS_TDR_PUCK_ARIA_LABEL_ACTIVE: "RYTE_GOALLESS_TDR_PUCK_ARIA_LABEL_ACTIVE",
  RYTE_GOALLESS_TDR_TOOLTIP_END_NOW: "RYTE_GOALLESS_TDR_TOOLTIP_END_NOW",
  RYTE_GOALLESS_TDR_TOOLTIP_ALL_EQUIPMENT: "RYTE_GOALLESS_TDR_TOOLTIP_ALL_EQUIPMENT",

  // === Goalless Visit-Based Occupancy Puck ===
  RYTE_VISIT_OCCUPANCY_TOOLTIP_TITLE: "RYTE_VISIT_OCCUPANCY_TOOLTIP_TITLE",
  RYTE_VISIT_OCCUPANCY_TOOLTIP_EQUIPMENT: "RYTE_VISIT_OCCUPANCY_TOOLTIP_EQUIPMENT",
  RYTE_VISIT_OCCUPANCY_TOOLTIP_VISIT: "RYTE_VISIT_OCCUPANCY_TOOLTIP_VISIT",
  RYTE_VISIT_OCCUPANCY_TOOLTIP_DOOR: "RYTE_VISIT_OCCUPANCY_TOOLTIP_DOOR",
  RYTE_VISIT_OCCUPANCY_TOOLTIP_START: "RYTE_VISIT_OCCUPANCY_TOOLTIP_START",
  RYTE_VISIT_OCCUPANCY_TOOLTIP_END_NOW: "RYTE_VISIT_OCCUPANCY_TOOLTIP_END_NOW",
  RYTE_VISIT_OCCUPANCY_TOOLTIP_ELAPSED: "RYTE_VISIT_OCCUPANCY_TOOLTIP_ELAPSED",
  RYTE_VISIT_OCCUPANCY_TOOLTIP_SOURCE: "RYTE_VISIT_OCCUPANCY_TOOLTIP_SOURCE",
  RYTE_VISIT_OCCUPANCY_TOOLTIP_SOURCE_VALUE: "RYTE_VISIT_OCCUPANCY_TOOLTIP_SOURCE_VALUE",
  RYTE_VISIT_OCCUPANCY_TOOLTIP_FOOTER: "RYTE_VISIT_OCCUPANCY_TOOLTIP_FOOTER",
  RYTE_VISIT_OCCUPANCY_PUCK_ARIA_LABEL: "RYTE_VISIT_OCCUPANCY_PUCK_ARIA_LABEL",

  // === IB Door to IB Door Transfer Modal ===
  RYTE_MODAL_IB_TRANSFER_TITLE: "RYTE_MODAL_IB_TRANSFER_TITLE",
  RYTE_MODAL_IB_TRANSFER_WARNING: "RYTE_MODAL_IB_TRANSFER_WARNING",
  RYTE_MODAL_IB_TRANSFER_CONFIRMATION_HEADING: "RYTE_MODAL_IB_TRANSFER_CONFIRMATION_HEADING",
  RYTE_MODAL_IB_TRANSFER_DESTINATION: "RYTE_MODAL_IB_TRANSFER_DESTINATION",
  RYTE_MODAL_IB_TRANSFER_DESTINATION_PLACEHOLDER: "RYTE_MODAL_IB_TRANSFER_DESTINATION_PLACEHOLDER",
  RYTE_MODAL_IB_TRANSFER_START_TIME: "RYTE_MODAL_IB_TRANSFER_START_TIME",
  RYTE_MODAL_IB_TRANSFER_END_TIME: "RYTE_MODAL_IB_TRANSFER_END_TIME",
  RYTE_MODAL_IB_TRANSFER_SUBMIT: "RYTE_MODAL_IB_TRANSFER_SUBMIT",
  RYTE_MODAL_IB_TRANSFER_GO_BACK: "RYTE_MODAL_IB_TRANSFER_GO_BACK",
  RYTE_MODAL_IB_TRANSFER_VALIDATION_DEST_REQUIRED:
    "RYTE_MODAL_IB_TRANSFER_VALIDATION_DEST_REQUIRED",
  RYTE_MODAL_IB_TRANSFER_VALIDATION_START_REQUIRED:
    "RYTE_MODAL_IB_TRANSFER_VALIDATION_START_REQUIRED",
  RYTE_MODAL_IB_TRANSFER_VALIDATION_END_REQUIRED: "RYTE_MODAL_IB_TRANSFER_VALIDATION_END_REQUIRED",
  RYTE_MODAL_IB_TRANSFER_VALIDATION_END_BEFORE_START:
    "RYTE_MODAL_IB_TRANSFER_VALIDATION_END_BEFORE_START",
  RYTE_MODAL_IB_TRANSFER_VALIDATION_UNAVAILABLE: "RYTE_MODAL_IB_TRANSFER_VALIDATION_UNAVAILABLE",
  RYTE_MODAL_IB_TRANSFER_VALIDATION_TIME_BEYOND_RANGE:
    "RYTE_MODAL_IB_TRANSFER_VALIDATION_TIME_BEYOND_RANGE",
  RYTE_MODAL_IB_TRANSFER_SUCCESS: "RYTE_MODAL_IB_TRANSFER_SUCCESS",
  RYTE_MODAL_IB_TRANSFER_ERROR_SOURCE_REMOVE: "RYTE_MODAL_IB_TRANSFER_ERROR_SOURCE_REMOVE",
  RYTE_MODAL_IB_TRANSFER_ERROR_DEST_UNLOAD: "RYTE_MODAL_IB_TRANSFER_ERROR_DEST_UNLOAD",
  RYTE_MODAL_IB_TRANSFER_ERROR_DEST_REMOVE: "RYTE_MODAL_IB_TRANSFER_ERROR_DEST_REMOVE",
  RYTE_MODAL_IB_TRANSFER_CONFLICT: "RYTE_MODAL_IB_TRANSFER_CONFLICT",
  // Planned IB Door Transfer (Feature 2)
  RYTE_MODAL_IB_TRANSFER_PLANNED_TITLE: "RYTE_MODAL_IB_TRANSFER_PLANNED_TITLE",
  RYTE_MODAL_IB_TRANSFER_EDIT_TITLE: "RYTE_MODAL_IB_TRANSFER_EDIT_TITLE",
  RYTE_MODAL_IB_TRANSFER_EDIT_SUBMIT: "RYTE_MODAL_IB_TRANSFER_EDIT_SUBMIT",
  RYTE_MODAL_IB_TRANSFER_EDIT_SUCCESS: "RYTE_MODAL_IB_TRANSFER_EDIT_SUCCESS",
  RYTE_MODAL_IB_TRANSFER_EDIT_PARTIAL_ALERT: "RYTE_MODAL_IB_TRANSFER_EDIT_PARTIAL_ALERT",
  RYTE_MODAL_IB_TRANSFER_PLANNED_SUCCESS: "RYTE_MODAL_IB_TRANSFER_PLANNED_SUCCESS",
  RYTE_MODAL_IB_TRANSFER_PLANNED_CONFLICT: "RYTE_MODAL_IB_TRANSFER_PLANNED_CONFLICT",
  RYTE_MODAL_IB_TRANSFER_VALIDATION_DEST_START_BEFORE_SOURCE_START:
    "RYTE_MODAL_IB_TRANSFER_VALIDATION_DEST_START_BEFORE_SOURCE_START",
  // Remove IB Door Transfer (Feature 2)
  RYTE_MODAL_REMOVE_IB_TRANSFER_TITLE: "RYTE_MODAL_REMOVE_IB_TRANSFER_TITLE",
  RYTE_MODAL_REMOVE_IB_TRANSFER_DESCRIPTION: "RYTE_MODAL_REMOVE_IB_TRANSFER_DESCRIPTION",
  RYTE_MODAL_REMOVE_IB_TRANSFER_CONFIRM: "RYTE_MODAL_REMOVE_IB_TRANSFER_CONFIRM",
  RYTE_MODAL_REMOVE_IB_TRANSFER_SUCCESS: "RYTE_MODAL_REMOVE_IB_TRANSFER_SUCCESS",
  RYTE_MODAL_REMOVE_IB_TRANSFER_CANCEL_FAILED: "RYTE_MODAL_REMOVE_IB_TRANSFER_CANCEL_FAILED",
  RYTE_MODAL_REMOVE_IB_TRANSFER_RESTORE_FAILED: "RYTE_MODAL_REMOVE_IB_TRANSFER_RESTORE_FAILED",
  RYTE_MODAL_REMOVE_IB_TRANSFER_PARTIAL_ALERT: "RYTE_MODAL_REMOVE_IB_TRANSFER_PARTIAL_ALERT",
};
